/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { Text } from '@blend/enterprise-components';
import React from 'react';
import { css, StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
  wrapper: {
    height: '100%',
    overflow: 'auto',
    display: 'flex',
    margin: '5px',
  },
  textDiv: {
    margin: 'auto',
  },
});

export const TextTableCell: React.FC<{ value: string }> = ({ value }) => {
  return (
    <div className={css(styles.wrapper)}>
      <div className={css(styles.textDiv)}>
        <Text>{value}</Text>
      </div>
    </div>
  );
};
